
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance",
      function () {
        return require("private-next-pages/insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurance"])
      });
    }
  